// File: frontend/src/pages/FitenkoToday.js
// Version: 1.1 (quick-260910-jkl — узор вынесен в общий слой)
// Date: 2026-09-10
// Назначение: экран «Сегодня» арендатора fitenko вместо общего /dashboard —
//             ЧЕТЫРЕ блока на СУЩЕСТВУЮЩИХ ручках.
//
// 🔴 УЗОРА ЗАМЫСЛА В ЭТОМ ФАЙЛЕ БОЛЬШЕ НЕТ. Шапка страницы и оболочка блока
//    переехали в components/FitenkoUzor.js (разметка) и в раздел 7.6
//    styles/fitenko-shell.css (оформление) — по одному держателю на каждое.
//    Здесь остались только СВОИ строчные примитивы: список, строка, время,
//    заголовок, таблетка, кнопка. Потребитель у них один — этот экран, и
//    выносить форму по одному потребителю значило бы её угадывать.
//
// 🔴 РУБЕЖ АРЕНДАТОРА СТОИТ НЕ ЗДЕСЬ, А В Dashboard.js: этот файл рисуется только
//    из-под `isFitenko` и второго рубежа не заводит. Второй рубеж означал бы двух
//    держателей одного решения, и разойтись им было бы нечем.
//
// 🔴 НИ ОДНОЙ ВЕЛИЧИНЫ, КОТОРОЙ НЕТ В ОТВЕТЕ РУЧКИ. Чего на экране НЕТ и почему:
//    (а) ПЛИТОК-СЧЁТЧИКОВ (ACTIVE BATTLES / BATTLES WON) нет вовсе. Они считали
//        работу СИСТЕМЫ, а не решения человека; у MLG они остались на месте.
//    (б) ТЁМНАЯ КАРТОЧКА «ГЛАВНОЕ СЕЙЧАС» ПОЯВИЛАСЬ (quick-260910-jmn) — и только
//        потому, что появилась ось отбора: СРОК. Он либо наступил, либо нет,
//        оценивать нечего. Токен --council-bg применён РОВНО ЗДЕСЬ и больше
//        нигде. Внутри карточки нет ни процента, ни уровня, ни шкалы: за ними
//        не стоит вычисления, а единственная крупная величина — число
//        оставшихся дней — посчитана НА СЕРВЕРЕ как разность двух дат.
//        🔴 ПУСТАЯ КАРТОЧКА — ОСНОВНОЙ СЛУЧАЙ, А НЕ ЗАГЛУШКА: на бою дел два и
//        сроков у них нет, так что в день выкатки её видят пустой все. Она
//        говорит, ЧЕГО нет, называет число и ведёт туда, где срок заводится.
//        «Ближайшего срока нет» и «срочного нет» — разные утверждения, и
//        последняя строка карточки запрещает их спутать.
//    (в) ПИЛЮЛИ «всё синхронизировано» нет: ручки состояния синхронизаций нет,
//        и зелёная пилюля была бы утверждением о том, чего не мерили.
//    (г) КНОПКИ «Request translation» нет: у ручки почты ровно два глагола,
//        approve и dismiss, перевода среди них нет.
//    (д) СВОЕГО ЧИСЛА ВСТРЕЧ блок встреч не печатает: counters.calendar считает
//        НЕДЕЛЮ, и рядом с дневным списком это были бы две разные величины под
//        одной подписью.
//    (е) СВОЕГО ИТОГА блок задач не печатает: правило «не DONE» повторено здесь
//        на клиенте, а на сервере оно живёт в nav_counters. Согласовать двух
//        держателей нечем, поэтому число остаётся ТОЛЬКО в колонке.
//
// 🔴 ТРИ СОСТОЯНИЯ У КАЖДОГО ЧИСЛА: число / ноль / НЕ ЗНАЕМ. «Не знаем» нигде не
//    нарисовано нулём — форму числа даёт ЕДИНСТВЕННЫЙ держатель chisloDlyaPunkta.
//    [[feedback_unknown_is_not_no]]
//
// 🔴 ОТКАЗ И СБОЙ ГОВОРЯТ РАЗНЫМИ СЛОВАМИ: 403 значит «не положено», прочее —
//    «не смогли спросить». Пустой список не означает ни того, ни другого.
//
// 🔴 ЧЕТЫРЕ КЛАССА БЕЗ ОФОРМЛЕНИЯ — НАМЕРЕННО, А НЕ ЗАБЫТЫ. fk-day-meets,
//    fk-day-inbox, fk-day-feed, fk-day-tasks не имеют ни одного правила в
//    разделе 9: они не красят, а ИМЕНУЮТ блок — тем же приёмом, каким это
//    делает fk-hist-card--<тип> на экране «История». По ним блок опознаётся в
//    инспекторе и сверяется прибором, не гадая по видимому заголовку. Правило
//    без потребителя проверено в обратную сторону: таких в разделе 9 — 0.
//    После выноса узора они приезжают вторым классом на общей оболочке блока:
//    оболочка НЕ ЗНАЕТ, чем именно её наполнили, и знать не должна.

import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import apiService from '../services/apiService';
import taskService from '../services/taskService';
import { useAuth } from '../context/AuthContext';
import { useNavCounters } from '../hooks/useNavCounters';
import { chisloDlyaPunkta } from '../components/FitenkoRail';
import { ShapkaEkrana, ObolochkaBloka, Sostoyanie } from '../components/FitenkoUzor';
import { metkaTipa, znachokTipa } from '../config/historyEvents';

// Держатели пределов показа. Каждое число названо и живёт в одном месте.
const PREDEL_SVODKI = 160;   // где обрезается ai_summary в свёрнутой строке
const POKAZ_LENTY = 8;       // сколько событий ленты показывает экран

const PUSTO = { rod: 'gruzim', dannye: [], prichina: null };

// Урезание. Многоточие НАЗЫВАЕТ обрезку: текст, оборванный без знака, читается
// как весь текст.
const urezat = (t, predel) => (String(t || '').length > predel
    ? `${String(t).slice(0, predel)}…`
    : String(t || ''));

// Порогов ровно два, те же, что в прежнем getTimeOfDay общего дашборда.
const privetstvie = () => {
    const h = new Date().getHours();
    return h < 12 ? 'Доброе утро' : h < 17 ? 'Добрый день' : 'Добрый вечер';
};

const vremya = (iso) => {
    const d = new Date(iso);
    if (!iso || Number.isNaN(d.getTime())) return '—';   // ПРОЧЕРК, А НЕ ВЫДУМАННОЕ ВРЕМЯ
    return d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
};

const data = (iso) => {
    const d = new Date(iso);
    if (!iso || Number.isNaN(d.getTime())) return null;
    return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' });
};

// Дата срока разбирается ПО ЧАСТЯМ, а не через new Date(строка). Голая дата
// «ГГГГ-ММ-ДД» читается как полночь UTC, и западнее Гринвича она съезжала бы на
// сутки назад — то есть срок печатался бы не тем днём, каким его поставили.
const dataSroka = (iso) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || ''));
    if (!m) return null;   // ПРОЧЕРК, А НЕ ВЫДУМАННАЯ ДАТА
    return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
        .toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' });
};

// Форма числа берётся у ЕДИНСТВЕННОГО держателя. «Не назвали» рисуется прочерком,
// а не нулём: ноль — измеренная величина, прочерк — её отсутствие.
const schet = (v) => chisloDlyaPunkta({ value: v }) || '—';

// Границы суток в местном времени браузера. Обе — ISO, как требует ручка.
const sutki = () => {
    const n = new Date();
    const s = new Date(n.getFullYear(), n.getMonth(), n.getDate());
    const e = new Date(s.getTime() + 24 * 60 * 60 * 1000);
    return [s.toISOString(), e.toISOString()];
};

const rod = (e) => (e && e.status === 403 ? 'otkaz' : 'sboj');

const FitenkoToday = () => {
    const { user } = useAuth();
    const counters = useNavCounters();

    const [vstrechi, postavitVstrechi] = useState(PUSTO);
    const [pisma, postavitPisma] = useState(PUSTO);
    const [lenta, postavitLentu] = useState(PUSTO);
    const [zadachi, postavitZadachi] = useState(PUSTO);
    const [raskryto, postavitRaskryto] = useState(null);   // id письма с раскрытым черновиком
    const [zanyat, postavitZanyat] = useState(null);       // id письма, по которому идёт действие
    const [tabletka, postavitTabletku] = useState(null);
    const [srok, postavitSrok] = useState(PUSTO);

    useEffect(() => {
        let zhiv = true;
        const [s, e] = sutki();
        apiService.getCalendarEvents(s, e)
            .then((r) => { if (zhiv) postavitVstrechi({ rod: 'gotovo', dannye: Array.isArray(r) ? r : [], prichina: null }); })
            .catch((err) => { if (zhiv) postavitVstrechi({ rod: rod(err), dannye: [], prichina: (err && err.message) || 'причина не названа' }); });
        return () => { zhiv = false; };
    }, []);

    // Список писем перечитывается ЦЕЛИКОМ после каждого действия. Клиентский
    // вычерк строки разошёлся бы с сервером на первом же отказе отправки.
    const zagruzitPisma = useCallback(() => {
        postavitPisma((p) => ({ ...p, rod: 'gruzim' }));
        return apiService.getPendingEmails()
            .then((r) => postavitPisma({ rod: 'gotovo', dannye: Array.isArray(r) ? r : [], prichina: null }))
            .catch((err) => postavitPisma({ rod: rod(err), dannye: [], prichina: (err && err.message) || 'причина не названа' }));
    }, []);

    useEffect(() => { zagruzitPisma(); }, [zagruzitPisma]);

    // Срок. Приём тот же, что у четырёх соседних блоков: отказ и сбой говорят
    // РАЗНЫМИ словами, пустой ответ не означает ни того, ни другого.
    useEffect(() => {
        let zhiv = true;
        apiService.getBlizhayshiySrok()
            .then((r) => { if (zhiv) postavitSrok({ rod: 'gotovo', dannye: r || {}, prichina: null }); })
            .catch((err) => { if (zhiv) postavitSrok({ rod: rod(err), dannye: {}, prichina: (err && err.message) || 'причина не названа' }); });
        return () => { zhiv = false; };
    }, []);

    useEffect(() => {
        let zhiv = true;
        apiService.getFirmHistory()
            .then((r) => { if (zhiv) postavitLentu({ rod: 'gotovo', dannye: r || {}, prichina: null }); })
            .catch((err) => { if (zhiv) postavitLentu({ rod: rod(err), dannye: {}, prichina: (err && err.message) || 'причина не названа' }); });
        return () => { zhiv = false; };
    }, []);

    useEffect(() => {
        let zhiv = true;
        taskService.getTasks({ assigned_to_me: true })
            .then((r) => { if (zhiv) postavitZadachi({ rod: 'gotovo', dannye: Array.isArray(r) ? r : [], prichina: null }); })
            .catch((err) => { if (zhiv) postavitZadachi({ rod: rod(err), dannye: [], prichina: (err && err.message) || 'причина не названа' }); });
        return () => { zhiv = false; };
    }, []);

    const otkrytye = useMemo(
        () => (zadachi.dannye || []).filter((z) => z && z.status !== 'DONE'),
        [zadachi.dannye],
    );

    // Таблетка рисуется ТОЛЬКО если за ней есть хоть одна задача В ЗАГРУЖЕННОМ
    // ОТВЕТЕ — приём с экрана «История». Таблетка, которой нечем наполниться, —
    // украшение. [[knowledge_decorative_flag]]
    const tabletki = useMemo(() => [
        { kluch: 'ai', metka: 'От ИИ', otbor: (z) => z.is_ai_generated === true },
        { kluch: 'hot', metka: 'Срочные', otbor: (z) => ['HIGH', 'URGENT'].includes(z.priority) },
    ].map((t) => ({ ...t, n: otkrytye.filter(t.otbor).length })).filter((t) => t.n > 0), [otkrytye]);

    const vidimyeZadachi = useMemo(() => {
        const t = tabletki.find((x) => x.kluch === tabletka);
        return t ? otkrytye.filter(t.otbor) : otkrytye;
    }, [otkrytye, tabletki, tabletka]);

    const sobytiya = useMemo(() => (lenta.dannye && lenta.dannye.events) || [], [lenta.dannye]);
    const imena = (lenta.dannye && lenta.dannye.lead_names) || null;

    const deystvie = (id, obeshanie) => {
        postavitZanyat(id);
        obeshanie.then(() => zagruzitPisma())
            .catch((err) => postavitPisma((p) => ({ ...p, rod: rod(err), prichina: (err && err.message) || 'причина не названа' })))
            .finally(() => { postavitZanyat(null); postavitRaskryto(null); });
    };

    // Строка о письмах на решении. Три состояния, и «не узнали» — не ноль.
    const chisloPisem = chisloDlyaPunkta(counters.inbox);
    const proPisma = chisloPisem === null
        ? 'сколько писем ждёт решения — не узнали'
        : (chisloPisem === '0' ? 'писем на решении нет' : `писем ждёт решения: ${chisloPisem}`);

    // Величины карточки берутся КАЖДАЯ СВОИМ полем ответа и не выводятся одна из
    // другой: «сколько названо поимённо» — длина присланного списка, а не догадка
    // о пределе показа, и разойтись с ним ей нечем.
    const bezSroka = (srok.dannye && srok.dannye.bez_sroka) || {};
    const nazvany = bezSroka.pokazano || [];

    const kalendarNePodklyuchen = !!(counters.calendar && counters.calendar.reason === 'calendar_not_connected');

    return (
        <div className="fk-page">
            {/* Имя не подставляется, если его не прислали: «Partner» вместо
                имени было бы выдумкой на первой строке экрана. */}
            <ShapkaEkrana
                nadzagolovok="Сегодня"
                zagolovok={`${privetstvie()}${user && user.first_name ? `, ${user.first_name}` : ''}`}
                podstroka={`${new Date().toLocaleDateString('ru-RU', {
                    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
                })} · ${proPisma}`}
                kuda="/email-inbox"
                podpis="Открыть почту →" />

            {/* КАРТОЧКА «ГЛАВНОЕ СЕЙЧАС» — НАД сеткой из четырёх блоков, во всю
                ширину. Построена ОБЩЕЙ оболочкой блока: второго держателя узора
                здесь не заводится, модификатор приезжает вторым классом. */}
            <ObolochkaBloka klass="fk-day-srok" zagolovok="Главное сейчас" kuda="/cases"
                  podpis="Все дела ›"
                  ogovorka="Отбор — по СРОКУ и только по нему: срок либо наступил, либо нет. Ничего оценочного — ни доли, ни балла, ни шкалы — здесь не считается: за такими величинами не стоит вычисления.">
                {srok.rod === 'gruzim' ? <Sostoyanie tekst="Спрашиваю сроки…" /> : null}
                {srok.rod === 'otkaz'
                    ? <Sostoyanie tekst={`Отказано в доступе к срокам: ${srok.prichina}. Это отказ по правам, а не отсутствие сроков.`} /> : null}
                {srok.rod === 'sboj'
                    ? <Sostoyanie tekst={`Сроки не получили: ${srok.prichina}. Это не «сроков нет».`} /> : null}
                {srok.rod === 'gotovo' && srok.dannye.srok ? (
                    <>
                        <p className="fk-day-srok-dney">
                            {schet(srok.dannye.srok.dney_ostalos)} дн.{' '}
                            <span className="fk-day-srok-kogda">до {dataSroka(srok.dannye.srok.deadline) || '—'}</span>
                        </p>
                        <p className="fk-day-srok-delo">
                            {srok.dannye.srok.case_number} — {srok.dannye.srok.title}{' '}
                            <Link className="fk-day-srok-ssylka" to={`/cases/${srok.dannye.srok.case_id}`}>Открыть дело ›</Link>
                        </p>
                        {srok.dannye.srok.deadline_reason
                            ? <p className="fk-day-srok-pochemu">Причина срока: {srok.dannye.srok.deadline_reason}</p>
                            : null}
                    </>
                ) : null}
                {srok.rod === 'gotovo' && !srok.dannye.srok
                    ? <Sostoyanie tekst={`Ближайшего срока нет: срок в будущем не проставлен ни у одного из ${schet(srok.dannye.vsego_del_vidno)} видимых дел.`} /> : null}
                {srok.rod === 'gotovo' ? (
                    <>
                        {/* ТРИ ЧИСЛА ПЕЧАТАЮТСЯ ВСЕГДА, ВКЛЮЧАЯ НУЛИ, и НИКОГДА не
                            складываются: «не спрашивали», «спросили — пока неизвестен»
                            и «в прошлом» отвечают на РАЗНЫЕ вопросы, а их сумма — ни
                            на один. Ветка «показывать, если > 0» отклонена: в день
                            выкатки её никто не исполнит, и она стояла бы в коде
                            гипотезой под видом работающего кода. */}
                        <p className="fk-day-srok-schet">
                            Дел без срока: {schet(bezSroka.vsego)} из {schet(srok.dannye.vsego_del_vidno)}
                            {' · '}признано «пока неизвестен»: {schet(srok.dannye.priznano_neizvestnymi)}
                            {' · '}сроков в прошлом: {schet(srok.dannye.proshedshie)}
                        </p>
                        {/* Сколько названо ПОИМЁННО — печатается ВСЕГДА, а не только при
                            усечении: молчаливое усечение есть ложь о полноте, а ветка,
                            которую в день выкатки никто не исполнит, ничего не сторожит. */}
                        <p className="fk-day-srok-pokaz">
                            Названы поимённо: {schet(nazvany.length)} из {schet(bezSroka.vsego)}
                        </p>
                        <ul className="fk-day-srok-spisok">
                            {nazvany.map((delo) => (
                                <li className="fk-day-srok-punkt" key={delo.case_id}>
                                    <span>{delo.case_number} — {delo.title}</span>
                                    <Link className="fk-day-srok-ssylka" to={`/cases/${delo.case_id}`}>Поставить срок ›</Link>
                                </li>
                            ))}
                        </ul>
                    </>
                ) : null}
                {srok.rod === 'gotovo' && !srok.dannye.srok ? (
                    <p className="fk-day-srok-pochemu">
                        Это не «срочного нет». Пока срок не проставлен, отбирать нечего.
                    </p>
                ) : null}
            </ObolochkaBloka>

            <div className="fk-day-cols">
                <ObolochkaBloka klass="fk-day-meets" zagolovok="Встречи сегодня" kuda="/calendar"
                      podpis="Весь календарь ›"
                      ogovorka="Показаны события Google-календаря. Встречи, записанные в обращении, сюда не приходят.">
                    {kalendarNePodklyuchen
                        ? <Sostoyanie tekst="Календарь не подключён — встречи неизвестны. Это не «встреч нет»." />
                        : null}
                    {!kalendarNePodklyuchen && vstrechi.rod === 'gruzim'
                        ? <Sostoyanie tekst="Спрашиваю календарь…" /> : null}
                    {!kalendarNePodklyuchen && vstrechi.rod === 'otkaz'
                        ? <Sostoyanie tekst={`Отказано в доступе к календарю: ${vstrechi.prichina}.`} /> : null}
                    {!kalendarNePodklyuchen && vstrechi.rod === 'sboj'
                        ? <Sostoyanie tekst={`Календарь не ответил: ${vstrechi.prichina}. Встреч может быть сколько угодно.`} /> : null}
                    {!kalendarNePodklyuchen && vstrechi.rod === 'gotovo' && vstrechi.dannye.length === 0
                        ? <Sostoyanie tekst="На сегодня встреч нет." /> : null}
                    {!kalendarNePodklyuchen && vstrechi.rod === 'gotovo' && vstrechi.dannye.length > 0 ? (
                        <ul className="fk-day-list">
                            {vstrechi.dannye.map((v, i) => (
                                <li className="fk-day-row" key={v.id || `${v.summary}-${i}`}>
                                    <span className="fk-day-time">{vremya(v.start && v.start.dateTime)}</span>
                                    <span className="fk-day-main">
                                        <span className="fk-day-title">{v.summary || '—'}</span>
                                        {v.attorney_name ? <span className="fk-day-who">{v.attorney_name}</span> : null}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    ) : null}
                </ObolochkaBloka>

                <ObolochkaBloka klass="fk-day-inbox" zagolovok="Ждут вашего решения" kuda="/email-inbox"
                      podpis="Вся почта ›"
                      ogovorka="«Одобрить и отправить» шлёт клиенту НАСТОЯЩЕЕ письмо — кнопка появляется только под раскрытым черновиком.">
                    {pisma.rod === 'gruzim' ? <Sostoyanie tekst="Спрашиваю почту…" /> : null}
                    {pisma.rod === 'otkaz'
                        ? <Sostoyanie tekst={`Отказано в доступе к очереди писем: ${pisma.prichina}. Это отказ по правам, а не пустая очередь.`} /> : null}
                    {pisma.rod === 'sboj'
                        ? <Sostoyanie tekst={`Очередь писем не получили: ${pisma.prichina}. Это не ноль.`} /> : null}
                    {pisma.rod === 'gotovo' && pisma.dannye.length === 0
                        ? <Sostoyanie tekst="Писем на решении нет." /> : null}
                    {pisma.rod === 'gotovo' && pisma.dannye.length > 0 ? (
                        <ul className="fk-day-list">
                            {pisma.dannye.map((p) => (
                                <li className="fk-day-row fk-day-row--stack" key={p.id}>
                                    <span className="fk-day-main">
                                        <span className="fk-day-title">{p.from_name || p.from_email || '—'}</span>
                                        {p.subject ? <span className="fk-day-meta">{p.subject}</span> : null}
                                        {p.ai_summary ? (
                                            <span className="fk-day-sum">{urezat(p.ai_summary, PREDEL_SVODKI)}</span>
                                        ) : null}
                                    </span>
                                    {/* Шеврон ПЕРЕКЛЮЧАЕТ ВИДИМОЕ и рисуется только там,
                                        где черновик есть. Без черновика раскрывать нечего. */}
                                    {p.ai_draft_reply ? (
                                        <button type="button" className="fk-day-chev"
                                                aria-label={raskryto === p.id ? 'Свернуть черновик' : 'Показать черновик'}
                                                onClick={() => postavitRaskryto(raskryto === p.id ? null : p.id)}>
                                            <ChevronDown size={14} strokeWidth={1.5} aria-hidden="true" />
                                        </button>
                                    ) : null}
                                    {raskryto === p.id && p.ai_draft_reply ? (
                                        <span className="fk-day-open">
                                            <span className="fk-day-draft">{p.ai_draft_reply}</span>
                                            {/* Текст письма НЕ передаётся вторым держателем:
                                                сервер шлёт ту же строку ai_draft_reply, которую
                                                мы показали. Своя копия разошлась бы с ней. */}
                                            <span className="fk-day-acts">
                                                <button type="button" className="fk-day-btn fk-day-btn--ok"
                                                        disabled={zanyat === p.id}
                                                        onClick={() => deystvie(p.id, apiService.approveEmail(p.id))}>
                                                    Одобрить и отправить
                                                </button>
                                                <button type="button" className="fk-day-btn"
                                                        disabled={zanyat === p.id}
                                                        onClick={() => deystvie(p.id, apiService.dismissEmail(p.id))}>
                                                    Отклонить
                                                </button>
                                            </span>
                                        </span>
                                    ) : null}
                                </li>
                            ))}
                        </ul>
                    ) : null}
                </ObolochkaBloka>

                <ObolochkaBloka klass="fk-day-feed" zagolovok="Что происходит в фирме" kuda="/history"
                      podpis="Вся история ›"
                      ogovorka={lenta.rod === 'gotovo'
                          ? `Показаны ${Math.min(POKAZ_LENTY, sobytiya.length)} из ${sobytiya.length} последних событий; вся лента — на /history.${
                              lenta.dannye && lenta.dannye.usecheno
                                  ? ' Лента упёрлась в предел чтения — событий в базе больше, чем отдала ручка.' : ''}`
                          : null}>
                    {lenta.rod === 'gruzim' ? <Sostoyanie tekst="Спрашиваю ленту фирмы…" /> : null}
                    {lenta.rod === 'otkaz'
                        ? <Sostoyanie tekst={`Отказано в доступе к ленте: ${lenta.prichina}. Это отказ по правам, а не пустая лента.`} /> : null}
                    {lenta.rod === 'sboj'
                        ? <Sostoyanie tekst={`Ленту не получили: ${lenta.prichina}. Это не ноль.`} /> : null}
                    {lenta.rod === 'gotovo' && sobytiya.length === 0
                        ? <Sostoyanie tekst="Ни одного события в ленте." /> : null}
                    {lenta.rod === 'gotovo' && sobytiya.length > 0 ? (
                        <ul className="fk-day-list">
                            {sobytiya.slice(0, POKAZ_LENTY).map((e) => {
                                const Znachok = znachokTipa(e.event_type);
                                const imya = imena ? imena[String(e.lead_id)] : null;
                                return (
                                    <li className="fk-day-row" key={e.id}>
                                        <span className="fk-day-time">{vremya(e.created_at)}</span>
                                        {Znachok ? <Znachok className="fk-day-icon" size={15} strokeWidth={1.5} aria-hidden="true" /> : null}
                                        <span className="fk-day-main">
                                            <span className="fk-day-type">{metkaTipa(e.event_type)}</span>
                                            <span className="fk-day-title">{e.title}</span>
                                            {imya ? <span className="fk-day-who">{imya}</span> : null}
                                        </span>
                                    </li>
                                );
                            })}
                        </ul>
                    ) : null}
                </ObolochkaBloka>

                <ObolochkaBloka klass="fk-day-tasks" zagolovok="Очередь задач" kuda="/tasks"
                      podpis="Все задачи ›"
                      ogovorka="Порядок — тот, каким отдала ручка задач; своего порядка у неё нет.">
                    {zadachi.rod === 'gruzim' ? <Sostoyanie tekst="Спрашиваю задачи…" /> : null}
                    {zadachi.rod === 'otkaz'
                        ? <Sostoyanie tekst={`Отказано в доступе к задачам: ${zadachi.prichina}.`} /> : null}
                    {zadachi.rod === 'sboj'
                        ? <Sostoyanie tekst={`Задачи не получили: ${zadachi.prichina}. Это не ноль.`} /> : null}
                    {zadachi.rod === 'gotovo' && otkrytye.length === 0
                        ? <Sostoyanie tekst="Открытых задач за вами нет." /> : null}
                    {zadachi.rod === 'gotovo' && otkrytye.length > 0 ? (
                        <>
                            {tabletki.length > 0 ? (
                                <div className="fk-day-pills">
                                    <button type="button"
                                            className={`fk-day-pill${tabletka === null ? ' active' : ''}`}
                                            onClick={() => postavitTabletku(null)}>
                                        Все ({otkrytye.length})
                                    </button>
                                    {tabletki.map((t) => (
                                        <button key={t.kluch} type="button"
                                                className={`fk-day-pill${tabletka === t.kluch ? ' active' : ''}`}
                                                onClick={() => postavitTabletku(t.kluch)}>
                                            {t.metka} ({t.n})
                                        </button>
                                    ))}
                                </div>
                            ) : null}
                            <ul className="fk-day-list">
                                {vidimyeZadachi.map((z) => (
                                    <li className="fk-day-row" key={z.id}>
                                        <span className="fk-day-main">
                                            <span className="fk-day-title">{z.title}</span>
                                            {z.due_date ? <span className="fk-day-meta">до {data(z.due_date) || z.due_date}</span> : null}
                                            {z.is_ai_generated ? <span className="fk-day-flag">ИИ</span> : null}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </>
                    ) : null}
                </ObolochkaBloka>
            </div>
        </div>
    );
};

export default FitenkoToday;
